import { LoadableAfterPaint, MustPreloadLoadableNames } from '@confluence/loadable';

import { EditorByLinePlaceholder } from '../src/by-line/EditorByLinePlaceholder.tsx';

export const EditorByLineArea = LoadableAfterPaint({
	name: MustPreloadLoadableNames.EditorByLineArea,
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorByLineArea" */ '../src/by-line/EditorByLineArea.tsx'
			)
		).EditorByLineArea,
	loading: EditorByLinePlaceholder,
});
